import {NgModule} from '@angular/core';

import {TableModule} from 'primeng/table';
import {DialogModule} from 'primeng/dialog';
import {ListboxModule} from 'primeng/listbox';
import {MultiSelectModule} from 'primeng/multiselect';
import {TooltipModule} from 'primeng/tooltip';
import {ChartModule} from 'primeng/chart';
import {PanelModule} from 'primeng/panel';
import {ConfirmDialogModule} from 'primeng/confirmdialog';
import {ProgressSpinnerModule} from 'primeng/progressspinner';
import {InputNumberModule} from "primeng/inputnumber";
import {DatePickerModule} from "primeng/datepicker";
import {PopoverModule} from "primeng/popover";
import {TabsModule} from "primeng/tabs";
import {ButtonModule} from "primeng/button";
import {ToastModule} from "primeng/toast";

export { ConfirmationService } from 'primeng/api';
export { MessageService } from 'primeng/api';

@NgModule({
  imports: [
    ButtonModule,
    TableModule,
    DialogModule,
    ListboxModule,
    MultiSelectModule,
    TabsModule,
    TooltipModule,
    ChartModule,
    PanelModule,
    ConfirmDialogModule,
    DatePickerModule,
    ProgressSpinnerModule,
    PopoverModule,
    InputNumberModule,
    ToastModule,
  ],
  exports: [
    ButtonModule,
    TableModule,
    DialogModule,
    ListboxModule,
    MultiSelectModule,
    TabsModule,
    TooltipModule,
    ChartModule,
    PanelModule,
    ConfirmDialogModule,
    DatePickerModule,
    ProgressSpinnerModule,
    PopoverModule,
    InputNumberModule,
    ToastModule,
  ],
  declarations: [],
})
export class PrimengModule {
  constructor() {}
}
